<template>
  <el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
    <div class="clients-panel cash-list">
      <div class="clients-panel-container">
        <el-row class="black-inputs">
          <div class="cash-header">
            <div class="nav-toggle" @click="showHideScreenCashList">
              <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
            </div>
          </div>
          <br>
          <el-row class="dateChooser" :gutter="5">
            <el-col :md="{ span: 8 }" :sm="{ span: 11 }" :xs="24">
              <el-date-picker class="datePicker" ref="picker" v-model="datesCash" :picker-options="pickerOptions"
                type="daterange" range-separator="-" start-placeholder="Date de début" end-placeholder="Date de fin"
                format="dd/MM/yyyy" />
            </el-col>
            <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11, offset: 2 }" :xs="24">
              <el-select v-model="typeCash" placeholder="Type">
                <el-option label="Caution" value="caution"></el-option>
                <el-option label="Prépaiement" value="prepaiement"></el-option>
              </el-select>
            </el-col>
            <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11 }" :xs="24">
              <el-select v-model="serviceCash" placeholder="Service">
                <el-option v-for="t in getAllServicesIdsAndName" :key="t" :label="t" :value="t">
                </el-option>
              </el-select>
            </el-col>
            <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11, offset: 2 }" :xs="24">
              <el-input class="inputEuro" placeholder="Prix / couverts" v-model="priceCash"></el-input>
            </el-col>
            <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11 }" :xs="24">
              <el-input class="inputCouv" placeholder="couverts min." v-model="nbCouv"></el-input>
            </el-col>
          </el-row>
          <el-row v-if="typeCash === 'caution'">
            <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11 }" :xs="24">
              <el-time-select v-model="limitHour" :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '72:00'
              }" :clearable="true" placeholder="Limite avant annulation">
              </el-time-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="{ span: 4, offset: 20 }" :xs="24" :sm="{ span: 12, offset: 12 }">
              <el-button type="primary" @click="createNewCashEntry()">Ajouter des dates</el-button>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="black-inputs">
          <el-col :md="24" class="screen-clients">
            <el-table ref="multipleTable" :data="getCashList">
              <el-table-column prop="startDate" label="Début" sortable>
                <template slot-scope="scope">
                  <span>{{ dateRenderer(scope.row.startDate) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="endDate" label="Fin" sortable>
                <template slot-scope="scope">
                  <span>{{ dateRenderer(scope.row.endDate) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="service" label="Service" sortable>
              </el-table-column>
              <el-table-column prop="type" label="Type" sortable>
                <template slot-scope="scope">
                  <span>{{ strUcFirst(scope.row.type) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="value" label="Prix" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.value }} €/c.</span>
                </template>
              </el-table-column>
              <el-table-column prop="nbCouv" label="Couverts min." sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.nbCouv }} c.</span>
                </template>
              </el-table-column>
              <el-table-column prop="limitHour" label="Annulation" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.limitHour }}</span>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <el-button class="dark" type="primary"
                    @click="editCashInfos(scope.row.startDate, scope.row.endDate, scope.row.service)">
                    <span class="mobile-show"><i class="el-icon-edit"></i></span>
                    <span class="mobile-hide">Modifier</span>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <el-popover placement="top" width="200" v-model="scope.row.popupValidDelete"
                    popper-class="popup-delete black-inputs">
                    <p>
                      Êtes vous sûr ?
                    </p>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" class="dark" type="primary"
                        @click="scope.row.popupValidDelete = false">Annuler</el-button>
                      <el-button type="primary" size="mini"
                        @click="deleteCashInfos(scope.row.startDate, scope.row.endDate, scope.row.service)">Confirmer</el-button>
                    </div>
                    <el-button class="red" type="primary" slot="reference">
                      <span class="mobile-show"><i class="el-icon-delete"></i></span>
                      <span class="mobile-hide">Supprimer</span>
                    </el-button>
                  </el-popover>
                  <!-- <el-button class="red" type="primary" @click="deleteCashInfos(scope.row.startDate, scope.row.endDate, scope.row.service)">Supprimer</el-button> -->
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 30px;">
              <el-pagination background layout="prev, pager, next" :total="total" @current-change="current_change">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-container>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { arrayOfTimestamp } from '../../tools/timeTool';

export default {
  name: 'CashList',
  components: {},
  data() {
    return {
      datesCash: {},
      typeCash: '',
      serviceCash: '',
      priceCash: null,
      nbCouv: null,
      limitHour: null,
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      loadingDelete: false,
      cashidEditing: '',
      pickerOptions: {
        firstDayOfWeek: 1
      }
    }
  },
  computed: {
    ...mapGetters({
      getAllServicesIdsAndName: 'newServices/getAllServicesIdsAndName',
      getCashDaysList: 'cash/getCashDaysList',
      getLabelMonth: 'calendar/getLabelMonth'
    }),
    getCashList: function () {
      // clone days
      let orderedDays = {}

      this.loading = true

      if (Object.entries(this.getCashDaysList).length > 0) {
        let days = Object.assign({}, this.getCashDaysList)
        // ordering main ts datas
        let orderDaysTab = Object.entries(days).sort(function (a, b) {
          return (Number(a[0]) > Number(b[0])) ? 1 : -1
        })
        // create tab
        orderDaysTab.forEach(([day, valDay]) => {
          let tzOffset = 0
          if (new Date(Number(day) - 86400000).getTimezoneOffset() !== new Date(Number(day) + 86400000).getTimezoneOffset()) {
            tzOffset = new Date().getTimezoneOffset() - new Date(Number(day)).getTimezoneOffset()
          }
          // min max range
          let min = Number(day) - 86400000 + (tzOffset * 60000)
          let max = Number(day) + 86400000
          Object.entries(valDay).forEach(([service, valCash]) => {
            // 24*3600
            let rangeId = -1
            if (!valCash.nbCouv) valCash.nbCouv = 1
            if (!valCash.limitHour) valCash.limitHour = '00:00'

            // check if in orderDays timestamp is == to + || - 24*3600 diff
            if (orderedDays[service] && orderedDays[service][valCash.type] && orderedDays[service][valCash.type][valCash.value] && orderedDays[service][valCash.type][valCash.value][valCash.nbCouv]) {
              orderedDays[service][valCash.type][valCash.value][valCash.nbCouv].forEach((tab, id) => {
                tab.forEach((content, idBis) => {
                  let testId = content.tsId
                  if ((testId === min || testId === max)) {
                    rangeId = id
                  }
                })
              })
            }
            if (rangeId === -1) {
              // create new if isn't exist service
              if (!orderedDays[service]) Vue.set(orderedDays, service, {})
              if (!orderedDays[service][valCash.type]) Vue.set(orderedDays[service], valCash.type, {})
              if (!orderedDays[service][valCash.type][valCash.value]) Vue.set(orderedDays[service][valCash.type], valCash.value.toString(), [])
              if (!orderedDays[service][valCash.type][valCash.value][valCash.nbCouv]) Vue.set(orderedDays[service][valCash.type][valCash.value], valCash.nbCouv.toString(), [])
              let range = []
              let obj = {
                tsId: Number(day),
                type: valCash.type,
                value: valCash.value,
                nbCouv: valCash.nbCouv,
                limitHour: valCash.limitHour
              }
              range.push(obj)
              orderedDays[service][valCash.type][valCash.value][valCash.nbCouv].push(range)
            } else { // else push in existing range tab obj to save
              let obj = {
                tsId: Number(day),
                type: valCash.type,
                value: valCash.value,
                nbCouv: valCash.nbCouv,
                limitHour: valCash.limitHour
              }
              orderedDays[service][valCash.type][valCash.value][valCash.nbCouv][rangeId].push(obj)
            }
          })
        })
        // format data for tab display
        let formatedTab = []
        Object.entries(orderedDays).forEach(([service, types]) => {
          Object.entries(types).forEach(([type, values]) => {
            Object.entries(values).forEach(([value, nbCouvs]) => {
              Object.entries(nbCouvs).forEach(([nbCouv, ranges]) => {
                ranges.forEach((cashDays, id) => {
                  let limitHour = cashDays[0].limitHour
                  let minId = cashDays[0].tsId
                  let maxId = cashDays[cashDays.length - 1].tsId
                  cashDays.forEach((content, idBis) => {
                    if (content.tsId < minId) minId = content.tsId
                    if (content.tsId > maxId) maxId = content.tsId
                  })
                  let convertMinDate = new Date(minId)
                  let convertMaxDate = new Date(maxId)
                  formatedTab.push({
                    startId: minId,
                    endId: maxId,
                    startDate: convertMinDate,
                    endDate: convertMaxDate,
                    value: value,
                    nbCouv: nbCouv,
                    limitHour: limitHour,
                    type: type,
                    service: service,
                    popupValidDelete: false
                  })
                })
              })
            })
          })
        })

        formatedTab.sort(function (a, b) {
          return a.startId - b.startId
        })

        this.total = formatedTab.length
        this.loading = false
        return formatedTab.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
      }
      this.loading = false
      return []
    },
    getEntrysIsValid: function () {
      if (this.priceCash) this.priceCash = this.priceCash.replace(',', '.')
      if (this.typeCash === 'caution' && (this.limitHour == null || this.limitHour === '')) return false
      if (this.datesCash.length > 1 &&
        this.typeCash !== '' &&
        this.serviceCash !== '' &&
        this.priceCash !== null &&
        this.nbCouv !== null &&
        (parseFloat(this.priceCash).toFixed(2).toString() === this.priceCash || parseFloat(this.priceCash).toString() === this.priceCash)) {
        return true
      }

      return false
    }
  },
  created: function () { },
  methods: {
    ...mapActions({
      createDaysAndService: 'cash/createDaysAndService',
      deleteDayCashDays: 'cash/deleteDayCashDays',
      showHideScreenCashList: 'displayer/showHideScreenCashList'
    }),
    ...mapMutations({
      setDialogError: 'displayer/setDialogError',
      setDialogEditCash: 'displayer/setDialogEditCash',
      setCashEditEntry: 'cash/setCashEditEntry'
    }),
    current_change: function (currentPage) {
      this.currentPage = currentPage
    },
    strUcFirst: function (a) {
      return ((`${a}`).charAt(0).toUpperCase() + a.substr(1))[0]
    },
    dateRenderer: function (date) {
      return `${this.leadingZero(date.getDate())}/${this.leadingZero(date.getMonth() + 1)}/${date.getFullYear()}`
    },
    leadingZero(value) {
      return (`0${value}`).slice(-2)
    },
    createNewCashEntry: function () {
      // Check entrys
      if (this.getEntrysIsValid) {
        // is valid
        let days = arrayOfTimestamp(this.datesCash[0], this.datesCash[1])
        // create entry
        this.createDaysAndService({
          days: days,
          service: this.serviceCash,
          content: {
            type: this.typeCash,
            value: Number(this.priceCash),
            nbCouv: Number(this.nbCouv),
            limitHour: this.limitHour
          }
        }).then(() => {
          this.datesCash = {}
          this.typeCash = ''
          this.serviceCash = ''
          this.priceCash = null
          this.nbCouv = null
          this.limitHour = null
        }).catch((err) => {
          console.error(err)
        })
      } else {
        // if not valid -> show popup notif error or something like this
        this.setDialogError(true)
      }
    },
    editCashInfos: function (start, end, service) {
      this.setCashEditEntry({
        days: arrayOfTimestamp(start, end),
        service: service
      })
      this.setDialogEditCash(true)
    },
    deleteCashInfos: function (start, end, service) {
      this.loadingDelete = true
      this.deleteDayCashDays({
        tIds: arrayOfTimestamp(start, end),
        service: service
      }).then(() => {
        this.loadingDelete = false
      })
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/mixins";

.cash-list {
  button {
    height: 48px;
  }

  .el-col {
    @include mixins.mobile-landscape {
      margin-bottom: 10px;
    }

    @include mixins.mobile-portrait {
      margin-bottom: 10px;
    }
  }

  .el-range {
    &-editor {
      @include mixins.mobile-portrait {
        height: 100% !important;
        width: 100% !important;
        display: block;
        text-align: center;
      }
    }

    &__icon {
      @include mixins.mobile-portrait {
        display: block;
        width: 100%;
      }
    }

    &-input {
      @include mixins.mobile-portrait {
        display: block;
        height: 35px;
        width: 100%;
      }
    }

    &-separator {
      @include mixins.mobile-portrait {
        display: block;
        width: 90%;
      }
    }

    &__close-icon {
      @include mixins.mobile-portrait {
        top: 0;
        right: 10px;
        height: 35px;
        position: absolute;
      }
    }
  }
}

.inputEuro {
  text-align: center;

  &:after {
    content: '€';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 16px;
  }
}

.inputCouv {
  text-align: center;

  &:after {
    content: 'couv.';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 14px;
  }
}

.el-input__inner {
  text-align: center;
  width: 100%;
}

.mobile-show {
  display: none;

  @include mixins.mobile-landscape {
    display: block;
  }
}

.mobile-hide {
  display: block;
  padding: 0 10px;

  @include mixins.mobile-landscape {
    display: none;
  }
}
</style>
